import React, { useState } from 'react'

import { Dropdown } from '@/components'
import { useTicketFiltersContext } from '@/context/filters/ticketFilters/ticketFilters'
import { Status } from '@/types/Ticket'

import { FilterOptionsStyled } from './PriorityFilter'

export const statusOptions = [
  { val: null, label: Status.ALL },
  {
    val: [Status.NEW, Status.WORKING, Status.NEEDS_ACTION, Status.AWAITING_RESPONSE, Status.ESCALATED],
    label: Status.OPEN,
  },
  { val: [Status.NEW], label: Status.NEW },
  { val: [Status.WORKING], label: Status.WORKING },
  { val: [Status.NEEDS_ACTION], label: Status.NEEDS_ACTION },
  { val: [Status.AWAITING_RESPONSE], label: Status.AWAITING_RESPONSE },
  { val: [Status.ESCALATED], label: Status.ESCALATED },
  { val: [Status.CLOSED], label: Status.CLOSED },
]

export const StatusFilter = () => {
  const { setFilters, ticketStatuses } = useTicketFiltersContext()
  const [dropdownExpanded, setDropdownExpanded] = useState(false)

  const handleCancel = () => {
    setDropdownExpanded(false)
  }

  const changeFilter = (val: string[] | null = null) => {
    setDropdownExpanded(false)
    setFilters({ ticketStatuses: val })
  }

  return (
    <Dropdown
      className="hidden w-full md:w-auto lg:flex"
      expanded={dropdownExpanded}
      headerTitle="Status"
      onHideDropdown={handleCancel}
      renderHeader={() => <div></div>}
      selected={!!ticketStatuses}
      setExpanded={setDropdownExpanded}
    >
      <FilterOptionsStyled>
        <ul>
          {statusOptions.map(({ val, label }, i) => (
            <li
              className={`${ticketStatuses?.toString() === val?.toString() ? 'selected' : ''} capitalize`}
              key={i}
              onClick={() => changeFilter(val)}
              role={'presentation'}
            >
              {label}
            </li>
          ))}
        </ul>
      </FilterOptionsStyled>
    </Dropdown>
  )
}
